import { Collapse } from '@/shared/common/collapse/collapse';

export const initVacanciesFaq = () => {
	const container = document.querySelector('.js-vacancies-faq');
	if (!container) return;

	new Collapse(container, {
		selectorElement: '.js-vacancies-faq > .collapse__element',
		selectorButton: '.collapse__button',
		selectorContent: '.collapse__content',
	});
};
